import React from "react";
import classNames from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
    TransactionListItemDto,
    TransactionStatus as TransactionStatusValues,
} from "../../common/types/transaction";
import { TRANSACTION_STATUS_LABELS } from "../../common/constants";
import { Tag } from "../general/Tag/Tag";
import { LockIcon } from "../../icons";
import styles from "./TransactionStatus.module.scss";

interface Props {
    transaction: TransactionListItemDto;
    className?: string;
    isLocked?: boolean;
}

export const TransactionStatus: React.FC<Props> = ({
    transaction,
    className,
    isLocked = false,
}) => {
    const variant =
        transaction.status === TransactionStatusValues.PENDING
            ? "secondary"
            : "danger";

    const statusTag =
        transaction.status === TransactionStatusValues.COMPLETED ? null : (
            <Tag
                variant={variant}
                className={classNames("transaction-status", className)}
                data-testid="transaction-status"
            >
                {TRANSACTION_STATUS_LABELS[transaction.status]}
            </Tag>
        );

    const lockTag = isLocked ? (
        <Tag
            variant="light"
            className={classNames("transaction-status", className)}
        >
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="lock-tooltip">
                        This transaction has been locked.
                        <br />
                        To unlock, go to <strong>Settings &gt; Locks</strong>
                    </Tooltip>
                }
            >
                <span className={styles.lockContainer}>
                    <span className={styles.lockIcon}>
                        <LockIcon className="icon-color-current mr-1" />
                    </span>
                    Locked
                </span>
            </OverlayTrigger>
        </Tag>
    ) : null;

    return (
        <>
            {statusTag}
            {lockTag}
        </>
    );
};
